import { useSyncExternalStore } from "react";

/**
 * Direct History API subscription — bypasses React Router's broken useLocation
 * in this app. Returns the current pathname and re-renders consumers on every
 * SPA nav (back/forward, NavLink clicks, programmatic navigate calls).
 *
 * Relies on the pushState/replaceState monkey-patch in App.tsx that fires
 * synthetic `pushstate`/`replacestate` events on every nav.
 */
export function usePathname(): string {
  return useSyncExternalStore(
    (cb) => {
      const handler = () => cb();
      window.addEventListener("popstate", handler);
      window.addEventListener("pushstate", handler);
      window.addEventListener("replacestate", handler);
      return () => {
        window.removeEventListener("popstate", handler);
        window.removeEventListener("pushstate", handler);
        window.removeEventListener("replacestate", handler);
      };
    },
    () => window.location.pathname,
    () => "/",
  );
}
